import { data } from "autoprefixer";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        referral: "",
        corporation: {
            is: false,
        },
        //fbAppID: "4259042120810172",
        fbAppID: "",
        // stripeKey: "pk_test_SZbWNuBtzBu4oTQWEfLWxg55009BAsQtSN",
        stripeKey: "",
        load: 0,
        loader: 0,
        appUrl: "",
        showSteps: true,
        showAppFilters: false,
        typeAppFilter: "map", // map, cause, causeSingle, partnerSingle
        showGoogleMap: false,
        loginActiveStep: "signUp",
        loginOperation: null,
        loginSteps: {
            signUp: false,
            cause: false,
            card: false,
            donation: false,
            finished: false,
        },
        loginShowOperationTitle: false,
        nposCategories: [],
        retailersCategories: [],
        userLocation: {
            lat: 0,
            lng: 0,
        },
        useUserLocation: false,
        useSearchLocation: false,
        searchLocation: {
            lat: 0,
            lng: 0,
        },
        userPlace: "",
        isNavigation: true,
        isOpenDetailsPage: false,
        filterWithoutMap: false,
        lastTransaction: 0,
        lastRoundUps: 0,
        monthDonation: 0,
        minAmount: 0,
        maxAmount: 0,
        totalDonation: 0,
        theme: "theme-default",
        themes: {
            "theme-amethyst": "#b620e0",
            "theme-iolite": "#6236ff",
            "theme-amazonite": "#44d7b6",
            "theme-emerald": "#6dd400",
            "theme-ruby": "#e02020",
            "theme-default": "#f68b23",
        },
        hash: null,
        startSign: true,
        forgotPasswordForm: false,
        showInstallMessage: false,
        device: "",
        showPwa: false,
        devicetype: null,
        step_header: false,
        showSignUpSlider: true,
        paymentModal: false,
        settingName: '',
        singleCause: null,
        userAddress: null,
        anotherLocation: null,
        userLocationTags: [],
        addressDetails: null,
        isConfirmModal: false,
        isBankAuthorized: null, //if false then contain id
        isCardDeclined: null, //if false then contain id
        isPosts: true,
        isCurrent: false,
        isLoaderModal: false,
        primaryLatlng: null,
        from: 'dashboard',
        isSpinner: false,
        isDateRangeModal: false
    },

    mutations: {
        isOpenDetailsPage(state, value) {
            state.isOpenDetailsPage = value;
        },
        device(state, value) {
            state.device = value;
        },
        showPwa(state, value) {
            state.showPwa = value;
        },
        showInstallMessage(state, value) {
            state.showInstallMessage = value;
        },
        startSign(state, value) {
            state.startSign = value;
        },
        forgotPasswordForm(state, value) {
            state.forgotPasswordForm = value;
        },
        user(state, value = false) {
            state.user = typeof value === "object" ? value : false;
        },
        userUpdate(state, value) {
            state.user = { ...state.user, ...value };
        },
        showSteps(state, value) {
            state.showSteps = value;
        },
        appUrl(state, value) {
            state.appUrl = value;
        },
        showAppFilters(state, value) {
            state.showAppFilters = value;
        },
        showGoogleMap(state, value) {
            state.showGoogleMap = value;
        },
        typeAppFilter(state, value) {
            state.typeAppFilter = value;
        },
        loginCauseChoice(state, value) {
            state.loginCauseChoice = value;
        },
        loginActiveStep(state, value) {
            state.loginActiveStep = value;
        },
        loginOperation(state, value) {
            state.loginOperation = value;
        },
        load(state, value) {
            state.load += value === 1 ? 1 : -1;
            if (state.load < 0) {
                state.load = 0;
            }
        },
        setLoader (state, flag) {
            state.loader = flag
        },
        loginSteps(state, value) {
            state.loginSteps = { ...state.loginSteps, ...value };
        },
        loginShowOperationTitle(state, value) {
            state.loginShowOperationTitle = value;
        },
        retailersCategories(state, value) {
            state.retailersCategories = value;
        },
        nposCategories(state, value) {
            state.nposCategories = value;
        },
        userLocation(state, value) {
            state.userLocation = value;
        },
        setPrimaryLatlng(state, value) {
            state.primaryLatlng = value
        },
        searchLocation(state, value) {
            state.searchLocation = value;
        },
        useUserLocation(state, value) {
            state.useUserLocation = value;
        },
        useSearchLocation(state, value) {
            state.useSearchLocation = value;
        },
        isNavigation(state, value) {
            state.isNavigation = value;
        },
        userPlace(state, value) {
            state.userPlace = value;
        },
        fbAppID(state, value) {
            state.fbAppID = value;
        },
        stripeKey(state, value) {
            state.stripeKey = value;
        },
        referral(state, value) {
            state.referral = value;
        },
        corporation(state, value) {
            state.corporation = { ...state.corporation, ...value };
        },
        corporationReset(state, value) {
            state.corporation = value;
            state.theme = "theme-default";
        },
        filterWithoutMap(state, value) {
            state.filterWithoutMap = value;
        },
        lastTransaction(state, value) {
            state.lastTransaction = value;
        },
        lastRoundUps(state, value) {
            state.lastRoundUps = value;
        },
        monthDonation(state, value) {
            state.monthDonation = value;
        },
        minAmount(state, value) {
            state.minAmount = value;
        },
        maxAmount(state, value) {
            state.maxAmount = value;
        },
        totalDonation(state, value) {
            state.totalDonation = value;
        },
        hash(state, value) {
            state.hash = value;
        },
        theme(state, value) {
            state.theme = value;
        },
        devicetype(state, value) {
            state.devicetype = value;
        },
        step_header(state, value) {
            state.step_header = value;
        },
        showSignUpSlider(state, value) {
            state.showSignUpSlider = value;
        },
        setPaymentModal(state, value) {
            state.paymentModal = value
        },
        setActiveSettings(state, value) {
            state.settingName = value
        },
        saveSingleCause(state, data) {
            state.singleCause = data
        },
        setCurrentLocation(state, data) {
            state.userAddress = data
        },
        setAddressWithLatLng(state, data) {
            state.addressDetails = data
        },
        setAnotherLocation(state, data) {
            state.anotherLocation = data
        },
        saveTagsForUserLocation(state, data) {
            const tagslist = [{
                id: 1,
                label: 'Home',
                icon: 'home'
            }, {
                id: 2,
                label: 'Work',
                icon: 'briefcase'
            }, {
                id: 3,
                label: 'Friends and Family',
                icon: 'high-five'
            }, {
                id: 4,
                label: 'Other',
                icon: 'location'
            }]
            state.userLocationTags = tagslist
        },
        setConfirmModal(state, data) {
            state.isConfirmModal = data
        },
        setLoaderModal(state, data) {
            state.isLoaderModal = data
        },
        setBankAuthorization(state, flag) {
            state.isBankAuthorized = flag
        },
        setCardDeclined(state, flag) {
            state.isCardDeclined = flag
        },
        setPostsFlag(state, flag) {
            state.isPosts = flag
        },
        setIsCurrent(state, flag) {
            state.isCurrent = flag
        },
        setFromComponent(state, str) {
            state.from = str
        },
        setSpinner(state, flag) {
            state.isSpinner = flag
        },
        setDateRangeModal (state, flag) {
            state.isDateRangeModal = flag
        }
    },
});
